import Image from '@atoms/Image';
import Text from '@atoms/Text';
import texts from '@components/Homepage/en.json';
import ExploreOpportunitiesButton from '../ExploreOpportunitiesButton';
import { buttonSizes } from '@ui/atoms/utils/enums';

const InvestmentJourney = ({ onButtonClick, ctaButtonText }) => {
    return (
        <div className="relative pt-[164px]  md:pt-[314px] flex flex-col items-center">
            <Image
                src="/images/homepage/jiraaf-mascot-2.webp"
                alt="Jiraaf-mascot"
                className="block top-[1.3rem] w-[178px] h-[164px] md:w-[264px] md:h-[248px] absolute md:top-[6.25rem]"
            />
            {/* <Image
                src="/images/homepage/JiraafMascot.webp"
                alt="Jiraaf-mascot"
                className="md:hidden  w-[244px] h-[394px] absolute -right-16 top-2"
            /> */}
            <div className="flex flex-col w-full items-center bg-primary-70 py-10 px-4 md:px-0">
                <Text
                    content={texts?.StartYourInvestment}
                    className="text-primary-500 h5-semibold md:h3-semibold text-center "
                    htmlTag='h2'
                />
                <ExploreOpportunitiesButton
                    onButtonClick={onButtonClick}
                    className="mt-4 !rounded-lg md:hidden"
                    gtmTag="gtm-click-explore-opportunities-btn-in-homepage"
                    ctaButtonText={ctaButtonText}
                    buttonSize={buttonSizes.REGULAR}
                />
                <ExploreOpportunitiesButton
                    onButtonClick={onButtonClick}
                    className="mt-4 xl:mt-6 !rounded-full hidden md:inline-block"
                    gtmTag="gtm-click-explore-opportunities-btn-in-homepage"
                    ctaButtonText={ctaButtonText}
                    buttonSize={buttonSizes.SMALL}
                />
            </div>
        </div>
    );
};

export default InvestmentJourney;